import React, { useState } from 'react'

import { useRouter } from 'next/router'

import { ArrowRightSmall } from '@/icons'
import clsx from 'clsx'

import { Link } from '@/components/CustomLink'

type SidebarLink = {
	text: string
	link?: {
		href: string
		target?: '_self' | '_blank'
		childLinks?: SidebarLink[]
	}
}

type Props = { item?: SidebarLink; width: number }

export const SidebarItem = ({ item, width }: Props) => {
	const { asPath } = useRouter()
	const { text, link } = item ?? {}
	const isParentActive = link ? asPath.split(/[?#]/)[0] === link?.href : false
	const [isOpen, setIsOpen] = useState(
		() => link?.href === asPath || link?.childLinks?.some(({ link }) => link?.href === asPath)
	)

	return (
		<div key={link?.href}>
			<div className="relative">
				<Link
					data-testid={
						isParentActive && width >= 768
							? 'sidebar-item-active-desktop'
							: isParentActive && width < 768
							? 'sidebar-item-active-mobile'
							: undefined
					}
					key={text}
					href={link?.href as string}
					onClick={() => setIsOpen(true)}
					className={clsx('flex items-center mb-4')}
				>
					<span
						className={clsx(
							isParentActive ? 'border-bc-blue' : 'border-transparent',
							'text-base font-normal text-gray-500 hover:text-black-100 border-b-2 border-solid'
						)}
					>
						{text}
					</span>
				</Link>
				{Boolean(link?.childLinks?.length) && (
					<ArrowRightSmall
						className={clsx(
							isOpen && '-rotate-90',
							'absolute top-[50%] rotate-90 -translate-y-[50%] right-0 fill-gray-700 cursor-pointer'
						)}
						onClick={() => setIsOpen(!isOpen)}
					/>
				)}
			</div>
			{isOpen && (
				<div className="border-l-[3px] border-solid border-gray-1000">
					{link?.childLinks?.map(({ text, link }) => (
						<Link
							key={text}
							href={link?.href as string}
							className="flex items-center mb-4 px-4"
							data-testid={
								link?.href.endsWith(asPath) && width >= 768
									? 'sidebar-item-active-desktop'
									: link?.href.endsWith(asPath) && width >= 768
									? 'sidebar-item-active-mobile'
									: undefined
							}
						>
							<span
								className={clsx(
									link?.href.endsWith(asPath) ? 'border-bc-blue' : 'border-transparent',
									'text-base font-normal text-gray-500 border-b-2 border-solid'
								)}
							>
								{text}
							</span>
						</Link>
					))}
				</div>
			)}
		</div>
	)
}
